import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

// Import du logo
import logoImage from '../images/mon-depannage-informatique-logo.webp';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src={logoImage} 
                alt="Excellence Informatique - Logo" 
                className="footer-logo-image"
              />
            </div>
            <p>Votre spécialiste en dépannage informatique à domicile en Loire-Atlantique.</p>
            <div className="contact-info">
              <p>📧 <Link to="/contact">Contactez-nous via notre formulaire</Link></p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/reparation/informatique/">Réparation Informatique</Link></li>
              <li><Link to="/reparation/pc/">Réparation PC</Link></li>
              <li><Link to="/reparation/ordinateur/">Réparation Ordinateur</Link></li>
              <li><Link to="/reparation/domicile/">Réparation à Domicile</Link></li>
              <li><Link to="/recuperation-de-donnees/">Récupération de Données</Link></li>
              <li><Link to="/micro-soudure-et-plasturgie/">Micro-soudure</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Zones d'Intervention</h4>
            <ul>
              <li><Link to="/accueil/domicile/loire-atlantique/">Loire-Atlantique</Link></li>
              <li><Link to="/accueil/domicile/ordinateur/zone/">Zone d'Intervention</Link></li>
              <li>Nantes et sa métropole</li>
              <li>Saint-Nazaire</li>
              <li>Châteaubriant</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Forfaits</h4>
            <ul>
              <li><Link to="/accueil/domicile/ordinateur/forfaits/windows/">Forfaits Windows</Link></li>
              <li><Link to="/accueil/domicile/ordinateur/forfaits/urgence/">Forfaits Urgence</Link></li>
              <li><Link to="/accueil/domicile/ordinateur/forfaits/formation/">Formation</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li><Link to="/contact">📧 Formulaire de contact</Link></li>
              <li><Link to="/contact">💬 Nous contacter</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Mon Dépannage Informatique - Tous droits réservés</p>
            <div className="footer-links">
              <Link to="/mentions-legales">Mentions légales</Link>
              <Link to="/plan-du-site">Plan du site</Link>
              <Link to="/politique-confidentialite">Politique de confidentialité</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
